import { Box } from "@mui/material";

import Navbar from "../Navbar/Navbar";
import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import "./Layout.scss";
import Sidnavbar from "../../../../Components/Sidnavbar/Sidnavbar";
import { useDispatch } from "react-redux";
import { listSideMenuPermission } from "../../../../Redux/Slices/SideMenuPermission/ListSideMenuPermissionSlice";
import Sidebar from "../SideNavbar/TutorSideNavbar";

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const scrollRef = useRef<HTMLDivElement>(null);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  // Scroll to top on route change
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname]);

  return (
    <div className="layout">
      {/* Sidebar */}
      <div className={`layout-sidebar ${sidebarOpen ? "open" : ""}`}>
        <Sidebar />
      </div>

      {/* Main Content */}
      <div className="layout-main">
        <Navbar toggleSidebar={() => setSidebarOpen(!sidebarOpen)} />

        <Box
          className="layout-content"
          ref={scrollRef}
          onClick={() => sidebarOpen && setSidebarOpen(false)}
          sx={{
            overflowY: "auto",
            height: "100%",
          }}
        >
          <Outlet />
        </Box>
      </div>
    </div>
  );
};

export default Layout;
